<template>
	<div class="section">
		<div class="container">
		<div class="tile is-ancestor is-flex is-flex-wrap-wrap is-justify-content-center">

			<!-- Food Distribution -->
			<div class="tile is-parent is-3">
			<router-link to="/fds" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-shopping-bag fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">FD</p>
			</router-link>
			</div>

			<!-- Beneficiaries -->
			<div class="tile is-parent is-3">
			<router-link to="/beneficiary" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-users fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Beneficiaries</p>
			</router-link>
			</div>

			<!-- Events -->
			<div class="tile is-parent is-3">
			<router-link to="/events" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-calendar-alt fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Events</p>
			</router-link>
			</div>

			<!-- Surveys -->
			<div class="tile is-parent is-3">
			<router-link to="/surveys" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-poll fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Surveys</p>
			</router-link>
			</div>

			<!-- Features -->
			<div class="tile is-parent is-3">
			<router-link to="/features" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-star fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Features</p>
			</router-link>
			</div>

			<!-- Commented Out: Reminders -->
			<!--
			<div class="tile is-parent is-3">
			<router-link to="/reminders" class="tile is-child notification has-background-link-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-bell fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Reminders</p>
			</router-link>
			</div>
			-->

			<!-- Commented Out: Users -->
			<!--
			<div class="tile is-parent is-3">
			<router-link to="/users" class="tile is-child notification has-background-info-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-user-cog fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Users</p>
			</router-link>
			</div>
			-->

			<!-- Commented Out: Content -->
			<!--
			<div class="tile is-parent is-3">
			<router-link to="/content" class="tile is-child notification has-background-link-light has-text-centered">
				<span class="icon is-large">
				<i class="fas fa-file-alt fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Content</p>
			</router-link>
			</div>
			-->

			<!-- Interests -->
			<div class="tile is-parent is-3">
			<router-link to="/interests" class="tile is-child notification has-background-warning-light has-text-centered" style="position: relative">
				<span v-if="newCount > 0" class="tag is-danger" style="position:absolute;top:0.5rem;right:0.5rem">{{ newCount }}</span>
				<span class="icon is-large">
				<i class="fas fa-hand-holding-heart fa-2x"></i>
				</span>
				<p class="title is-6 mt-2">Interests</p>
			</router-link>
			</div>

		</div>
		</div>
	</div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

onMounted(() => {
    store.dispatch('interests/subscribeInterests');
});

const newCount = computed(() => store.getters['interests/getNewInterestCount']);
</script>
